export type ReviewStatus = 'pending' | 'approved' | 'rejected';
export type ReviewStatusFilter = 'all' | ReviewStatus;

export interface Review {
  id: string;
  productId: string;
  productName: string;
  productSlug?: string;
  productSku?: string;
  reviewerName: string;
  reviewerEmail?: string;
  customerId?: string;
  rating: number;
  comment: string;
  status: ReviewStatus;
  moderatedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedReviews {
  results: Review[];
  total: number;
  page: string | number;
  limit: string | number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface ProductReviewsResult {
  results: Review[];
}

export interface ReviewListParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  status?: ReviewStatus;
  rating?: number;
  productId?: string;
  customerId?: string;
}

export interface BulkReviewIdsPayload {
  ids: string[];
}

export interface ModerateReviewPayload {
  status: Exclude<ReviewStatus, 'pending'>;
}

export interface BulkModerateReviewsPayload extends BulkReviewIdsPayload {
  status: Exclude<ReviewStatus, 'pending'>;
}

export const REVIEW_STATUS_OPTIONS = [
  { label: 'Pending', value: 'pending' as const },
  { label: 'Approved', value: 'approved' as const },
  { label: 'Rejected', value: 'rejected' as const },
];

export const REVIEW_RATING_OPTIONS = [1, 2, 3, 4, 5].map((value) => ({
  label: `${value} star${value === 1 ? '' : 's'}`,
  value,
}));
